import React, { useState } from 'react'
import { useForm } from 'react-hook-form'

import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'

import TelegramLogo from './../../assets/img/telegram-logo.png'
import AresLogo from './../../assets/img/ares-logo.png'

import { FaPlus } from 'react-icons/fa';
import { BiCheckCircle } from 'react-icons/bi'

import http from './../../services/Api'

import {
    useParams
} from "react-router-dom";


import './index.css'

export default function TelegramLink({ history, location }) {
    let { chatId } = useParams();
    const { register, handleSubmit } = useForm();

    const [success, setSuccess] = useState(false);

    const authenticate = async formData => {
        const { username, password } = formData;

        try {
            let response = await http.post('/api/authenticate', {
                username,
                password
            })
            const { token } = response.data
            await link(token.token);
        } catch (e) {
            alert(e.response.data.error)
        }
    }

    const link = async token => {
        const headers = {
            'Authorization': 'Bearer ' + token
        };
        try {
            const response = await http.post(`/api/me/telegram/${chatId}/link`, {}, {
                headers: headers
            });
            setSuccess(true);
            console.log(response.data);
        } catch (e) {
            throw e;
        }
    }

    return (
        <div className="TelegramLink">
            <div className="content">
                <div className="container-form">
                    <Form onSubmit={handleSubmit(authenticate)}>
                        <div className="text-center">
                            <h2>Vincular contas</h2>
                        </div>

                        <div className="container-logo">
                            <img src={AresLogo} className="ares" />
                            <FaPlus />
                            <img src={TelegramLogo} className="telegram" />
                        </div>

                        {!success ? (
                            <div className="inputs">
                                <Form.Group controlId="formBasicEmail">
                                    <Form.Label>Usuário</Form.Label>
                                    <Form.Control type="text" ref={register} name="username" placeholder="Digite o nome de usuário" />
                                </Form.Group>

                                <Form.Group controlId="formBasicPassword">
                                    <Form.Label>Senha</Form.Label>
                                    <Form.Control type="password" name="password" ref={register} placeholder="Senha" />
                                </Form.Group>
                                <Button variant="primary" type="submit">
                                    Fazer Login
                     </Button>
                            </div>
                        ) : (
                                successPage()
                            )}
                    </Form>
                </div>
            </div>
        </div>
    )

    function successPage() {
        return (
            <div className="container-success">
                <BiCheckCircle />
                <h3>Vinculado com sucesso!</h3>
            </div>
        )
    }
}